import './CodeSnippet.css';
export var codeSnippetCSS = '_11i182x0-2-0-1';
export var codeSnippetCopyButtonContainerCSS = '_11i182x1-2-0-1';